import axios from '@/axios.config.js';

class SessionService {
    createSession(cancelToken, classId, data) {
        return axios
            .post(`classes/${classId}/sessions`, {
                session_date: data.session_date,
                time_start: data.time_start,
                time_end: data.time_end,
                type: data.type,
                static_link: data.static_link,
                iframe: data.iframe,
                room_id: data.room_id,
                description: data.description,
                attachments: data.attachments,
            }, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    updateSession(cancelToken, classId, data) {
        return axios
            .patch(`classes/${classId}/sessions/${data.id}`, {
                session_date: data.session_date,
                time_start: data.time_start,
                time_end: data.time_end,
                type: data.type,
                static_link: data.static_link,
                iframe: data.iframe,
                room_id: data.room_id,
                description: data.description,
                attachments: data.attachments,
                klass_teaching_file_name: data.klass_teaching_file_name,
            }, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    deleteSession(cancelToken, classId, sessionId) {
        return axios
            .delete(`classes/${classId}/sessions/${sessionId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    getSession(cancelToken, classId, sessionId) {
        return axios
            .get(`classes/${classId}/sessions/${sessionId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listSessions(cancelToken, classId) {
        return axios
            .get(`classes/${classId}/sessions`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listPresentLogs(cancelToken, classId, sessionId) {
        return axios
            .get(`classes/${classId}/sessions/${sessionId}/present-logs`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    getSessionUrl(cancelToken, classId, sessionId) {
        return axios
            .get(`classes/${classId}/sessions/${sessionId}/link`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

}

export default new SessionService();